<template>
    <div class="request_form">
        <section>
            <div class="artpackTypeButtons">
                <center>
                    <input v-if="form.artpack_number === ''" type="radio" v-model="form.form_type" value='existing' name="existing" id="existing" />
                    <label v-if="form.artpack_number === ''" for="existing">Existing</label>
                    <input type="radio" v-model="form.form_type" value='new' name="new" id="new" />
                    <label for="new">New</label>
                </center>
            </div>
            <div v-show="form.form_type" class="row">
                <div class="col-lg-12">
                    <div class="panel-body">
                        <!-- <div class="back"><a class="back" href="javascript:location.reload(true)">≤ Back</a></div> -->
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h3 class="panel-title">
                                            <span class="ng-scope"><i class="fa fa-fw ti-pencil"></i> Component Request</span>
                                        </h3>
                                    </div>
                                    <div class="panel-body">
                                        <div>
                                            <form v-on:submit.prevent="submitForm()" enctype="multipart/form-data" ref="asi_input" name="containerform" id="formContainer" autocomplete="on" class="form-horizontal" role="form">
                                                <fieldset v-if="form.form_type === 'existing'">
                                                    <legend>Form Number</legend>
                                                    <div class="col-12">
                                                        <div style="width:100%;text-align:center;">
                                                            <label class="control-label col-sm-4" for="form_num">Form #
                                                            </label>
                                                            <div class="col-sm-4">
                                                                <input v-model="form.form_num" name="form_num" type="text" id="form_num" class="form-control" required/>
                                                                <h4 style="width:100%;float:left;color:red;text-align:center;">
                                                                    DO NOT PUT ABBREVIATIONS IN FRONT OF THE FORM #
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <fieldset style="height:auto;">
                                                    <input type="hidden" name="userId" :value="this.$store.state.user.id" />
                                                    <input type="hidden" name="userName" :value="this.$store.state.user.name" />
                                                    <input type="hidden" name="userDepartment" :value="this.$store.state.user.department" />
                                                    <input type="hidden" name="userPicture" :value="this.$store.state.user.picture" />
                                                    <input type="hidden" name="type" value="component" />
                                                    <legend>Account Information</legend>
                                                    <div class="col-sm-12" style="height: auto;">
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="customer_name">Customer Name
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.customer_name" name="customer_name" type="text" id="customer_name" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="account_name">Account Name
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.account_name" name="account_name" type="text" id="account_name" class="form-control" required />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="account_number">Account Number
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.account_number" name="account_number" type="text" id="account_number" class="form-control" required />
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="typeOfRequest !== 'save'">
                                                            <label class="control-label col-sm-4" for="csr_name">CSR
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <v-select v-if="csr_options !== null" style="height:34px;padding:0;" v-model="form.csr_name" :options="csr_options" required></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="turn_time">Turn Time
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <select name="turn_time" v-model="form.turn_time" tabindex="1" id="turn_time" class="form-control select2">
                                                                    <option value="2 Days" selected>2 days</option>
                                                                    <option value="Rush">Rush</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" style="height:auto;" v-if="typeOfRequest !== 'save'">
                                                            <label class="control-label col-sm-4" for="turn_time">Vendor Direct?
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <div class="col-sm-6">
                                                                    <label>
                                                                        <input v-model="form.vendor" type="radio" value="1" /><span>Yes</span></label>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <label>
                                                                        <input v-model="form.vendor" type="radio" value="0" /><span>No</span></label>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12" style="position:relative;margin-top:15px;height:auto;" v-show="parseInt(form.vendor) === 1">
                                                                <div class="col-sm-4">
                                                                    <input type="text" class="form-control" v-model="form.vendor_direct.company_name" placeholder="Company Name..">
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <input type="text" class="form-control" v-model="form.vendor_direct.contact_name" placeholder="Contact Name..">
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <input type="text" class="form-control" v-model="form.vendor_direct.contact_info" placeholder="Contact Info..">
                                                                </div>
                                                                <div style="margin-top:10px;" class="col-sm-6 col-md-6">
                                                                    <input type="number" class="form-control" name="quantity" v-model.number="form.quantity_info[0].ordered" placeholder="Quantity...">
                                                                </div>
                                                                <div style="margin-top:10px;" class="col-sm-6 col-md-6">
                                                                    <input type="text" name="in_house_date" class="form-control" id="datetime" placeholder="In House Date..." />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="typeOfRequest !== 'save'">
                                                            <label class="control-label col-sm-4" for="turn_time">Exact Copy From Artpack?
                                                            </label>
                                                            <div class="col-sm-8 checkarea2 container">
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.exact_artpack" name="exact_artpack" type="radio" value="1" required /><span>Yes</span></label>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.exact_artpack" name="exact_artpack" type="radio" value="0" /><span>No</span></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-2" for="logo_manip">Pickleball?</label>
                                                            <div class="col-sm-10 checkarea2 container">
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.pickleball" type="radio" value="1" required /><span>Yes</span></label>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.pickleball" type="radio" value="0" /><span>No</span></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <fieldset>
                                                    <legend>Component Details</legend>
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="job_name">Job Name
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.job_name" tabindex="1" name="job_name" type="text" id="job_name" class="form-control" required />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="reference_number">Reference #
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.reference_number" tabindex="1" name="reference_number" type="text" id="reference_number" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="reference_number">CC #
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.cc_number" tabindex="1" name="cc_number" type="text" id="cc_number" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="reference_number">Log #
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input v-model="form.log_number" tabindex="1" name="log_number" type="text" id="log_number" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="component_description">Description
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <v-select style="text-transform: capitalize;" name="component_description" placeholder="Select Component Type" v-model="form.component_description" required :options="typeOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-4" for="component_type">Type
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control" disabled name="component_type" v-model="component_type" required />
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="control-label col-sm-12" style="text-align:left;" for="location">Location
                                                            </label>
                                                            <div class="col-sm-12">
                                                                <v-select style="text-transform: capitalize;" name="location" placeholder="Select Location" v-model="form.location" required :options="locationOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="vendorsOptions && vendorsOptions.length">
                                                            <label class="control-label col-sm-12" style="text-align:left;" for="component_description">Vendor Selection
                                                            </label>
                                                            <div class="col-sm-12">
                                                                <v-select style="text-transform: capitalize;" name="vendor_selection" placeholder="Select Vendor" label="name" v-model="form.vendor_selection" :disabled="vendorsOptions.length === 1" required :options="vendorsOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="component_type === 'PPCH'">
                                                            <label class="control-label col-sm-4" for="component_description">Felt Color
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <v-select style="text-transform: capitalize;" name="felt_color" placeholder="Select Felt Color" v-model="form.color_option" required :options="feltOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="component_type === 'PPRL'">
                                                            <label class="control-label col-sm-12" style="text-align:left;" for="component_description">Color
                                                            </label>
                                                            <div class="col-sm-12">
                                                                <v-select style="text-transform: capitalize;" name="felt_color" placeholder="Select Felt Color" v-model="form.color_option" required :options="feltOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="form-group" v-if="component_type === 'PPCH'">
                                                            <label class="control-label col-sm-4" for="yarn_options">Yarn
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <v-select style="text-transform: capitalize;" name="yarn_option" placeholder="Select Felt Color" v-model="form.yarn_option" required :options="yarnOptions"></v-select>
                                                            </div>
                                                        </div> -->
                                                        <div class="form-group" v-if="component_type === 'PPL'">
                                                            <label class="control-label col-sm-4" for="turn_time">World Emblem?
                                                            </label>
                                                            <div class="col-sm-8 checkarea2 container">
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.world_emblem" name="world_emblem" type="radio" value="1" required /><span>Yes</span></label>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <label>
                                                                        <input v-model="form.world_emblem" name="world_emblem" type="radio" value="0" /><span>No</span></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="component_type === 'PPTA' || component_type === 'PPFSE'">
                                                            <label class="control-label col-sm-12" style="text-align:left;" for="yarn_options">Combo
                                                            </label>
                                                            <div class="col-sm-12">
                                                                <v-select style="text-transform: capitalize;" name="combo" placeholder="Select Felt Color" v-model="form.combo" required :options="comboOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div style="width:100%;float:left;" v-if="component_type === 'PPTA' && form.combo" v-for="v in form.felt_yarn_options">
                                                            <div class="form-group">
                                                                <label class="control-label col-sm-4" for="component_description">Felt Color
                                                                </label>
                                                                <div class="col-sm-8">
                                                                    <v-select style="text-transform: capitalize;" @input="feltChanged(v)" name="felt_color" placeholder="Select Felt Color" v-model="v.felt" required :options="feltOptions"></v-select>
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="control-label col-sm-4" for="yarn_options">Yarn
                                                                </label>
                                                                <div class="col-sm-8">
                                                                    <v-select :disabled="component_type === 'PPTA'" style="text-transform: capitalize;" name="yarn_option" placeholder="Select Felt Color" v-model="v.yarn" required :options="yarnOptions"></v-select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="component_type === 'PPFL'">
                                                            <label class="control-label col-sm-4" for="yarn_options">Yarn
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <v-select style="text-transform: capitalize;" name="yarn_option" placeholder="Select Felt Color" v-model="form.color_option" required :options="colorOptions"></v-select>
                                                            </div>
                                                        </div>
                                                        <div class="form-group" v-if="component_type === 'PPPV'">
                                                            <label class="control-label col-sm-4" for="yarn_options">Application Type
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <!-- <v-select style="text-transform: capitalize;" name="yarn_option" placeholder="Select Tech Option" v-model="form.combo" required :options="techOptions"></v-select> -->
                                                                <select class="form-control" v-model="form.combo" required>
                                                                    <option value="">Select Tech Option</option>
                                                                    <option v-for="v in techOptions" :value="v">{{v}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="form.component_description === '3D insignia'" class="col-12">
                                                        <label class="control-label col-md-12" style="text-align:center;font-weight: 900;" for="position">
                                                            Insignia Options
                                                        </label>
                                                        <div class="col-md-12" style="margin-top:15px;border-bottom:1px solid #e0e0e0;padding-bottom:25px;">
                                                            <label class="control-label col-sm-6" style="text-align:center;">
                                                                <input v-model="form.style1" type="radio" name="style1" value="Deco Textured" required>
                                                                <span>Insignia - Textured (TEXTURA)</span>
                                                            </label>
                                                            <label class="control-label col-sm-6" style="text-align:center;">
                                                                <input v-model="form.style1" type="radio" name="style1" value="Deco Flat">
                                                                <span>Insignia Dome - (DOME X FLAT)</span>
                                                            </label>
                                                            <label class="control-label col-sm-6" style="text-align:center;">
                                                                <input v-model="form.style1" type="radio" name="style1" value="Deco Beveled">
                                                                <span>Insignia - Beveled</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div v-if="component_type !== 'PPHI' && component_type !== 'PPSM' && component_type !== 'PPE' && component_type !== '' && component_type !== 'PPSN' && component_type !== 'PPAS'" class="form-group packagetype" style="padding-bottom:18px;">
                                                        <label class="control-label col-md-2 packagetype" for="package_type">Factory
                                                        </label>
                                                        <div class="col-md-10 checkarea2 container">
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('c1')" type="checkbox" value="c1" /><span>C1 - Mainland</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('a5')" type="checkbox" value="a5" /><span>A5 - Atta</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('a1')" type="checkbox" value="a1" /><span>A1 - Asian</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('cb')" type="checkbox" value="cb" /><span>CB - Mainland-BD</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('mi')" type="checkbox" value="mi" /><span>MI - Minheng</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('sd')" type="checkbox" value="sd" /><span>SD - Shangahi Dowell</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('tl')" type="checkbox" value="tl" /><span>TL - Tinlung</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('sc')" type="checkbox" value="sc" /><span>SC - South China</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input @click="factoryClick('hma')" type="checkbox" value="hma" /><span>HMA - HMA</span></label>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <label>
                                                                    <input v-model="form.factory_option" type="checkbox" value="other" />
                                                                    <span>Other</span>
                                                                    <br />
                                                                    <input style="text-align:left;float:right;height:25px;margin-top:2px;margin-left:5px;width:100px !important;" type="text" v-show="form.factory_option === 'other'" v-model="form.factoryOther" name="factoryOther" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <fieldset>
                                                    <legend>Comments</legend>
                                                    <div class="form-group full autoheight">
                                                        <!-- <vue-editor v-model="form.comments" tabindex="1" name="comments" :options="options" id="component_comments" required></vue-editor> -->
                                                        <textarea style="width:100%;" v-model="form.comments" rows="7"></textarea>
                                                    </div>
                                                </fieldset>
                                                <div style="width:100%;float:left;">
                                                    <select-images :group="group"></select-images>
                                                </div>
                                                <div class="col-12 float-left">
                                                    <legend>Attach Reference Art</legend>
                                                        <div style="width: 100%;float:left;" class="form-group full autoheight">
                                                            <reference-art @image-selected="imageSelected"></reference-art>
                                                        </div>
                                                </div>
                                                <div class="form-actions float-left">
                                                    <div class="col-sm-12">
                                                        <input v-if="typeOfRequest === 'new'" type="submit" class="btn btn-primary" tabindex="-1" value="Submit Request" />
                                                        <input v-if="typeOfRequest === 'save'" type="submit" class="btn btn-primary" tabindex="-1" value="Save Request" />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
var methods = {}
import SelectImages from './select_images'
import ReferenceArt from './reference_art'
import { buildRequestPrefill } from './request_prefill'

methods.submitForm = function () {
    this.form.component_type = this.component_type
  const postData = {
    form: this.form
  }
  axios.post(this.$apiAdress + '/api/flow/submitComponent?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.$emit('submitted')
  })
}

// methods.submitForm = function() {

//     var form = document.querySelector('form')
//     var that = this
//     // var form = document.querySelector("#container").form
//     console.log(that.form.style1)
//     if (that.typeOfRequest !== 'save') {
//         if (that.form.comments !== '' && that.component_type !== null && that.form.component_description !== '') {
//             this.form.quantity_info[0].in_house_date = document.getElementById('datetime').value
//             var request = new XMLHttpRequest()
//             var formData = new FormData(form)
//             // var comments = new FormData()
//             // console.log(comments)
//             console.log(formData)
//             request.open('post', componentSubmit)
//             formData.append('comments', that.form.comments)
//             formData.append('userDepartment', that.$store.state.user.department)
//             formData.append('csr_name', that.form.csr_name.value)
//             formData.append('component_type', that.component_type)
//             formData.append('vendor', that.form.vendor)
//             formData.append('style1insig', that.form.style1)
//             formData.append('artpack_number', that.form.artpack_number)
//             formData.append('type', 'component')
//             formData.append('userId', that.$store.state.user.id)
//             formData.append('style2', that.form.style2)            
//             formData.append('vendor_direct', JSON.stringify(that.form.vendor_direct))
//             formData.append('quantity_info', JSON.stringify(that.form.quantity_info))
//             formData.append('component_description', that.form.component_description)
//             formData.append('style1', that.form.component_description)            
//             formData.append('form_type', that.form.form_type)
//             formData.append('form_num', that.form.form_num)
//             formData.append('turn_time', that.form.turn_time)
//             formData.append('yarn_option', that.form.yarn_option)
//             formData.append('color_option', that.form.color_option)
//             formData.append('job_name', that.form.job_name)
//             formData.append('reference_number', that.form.reference_number)
//             formData.append('customer_name', that.form.customer_name)
//             formData.append('image', that.form.image)
//             formData.append('account_name', that.form.account_name)
//             formData.append('account_number', that.form.account_number)
//             formData.append('exact_artpack', that.form.exact_artpack)
//             formData.append('cc_number', that.form.cc_number)
//             formData.append('log_number', that.form.log_number)
//             formData.append('factory_option', JSON.stringify(that.form.factory_option))

//             if (this.task) {
//                 if (this.task.type === 'escape') {
//                     formData.append('escape', true)
//                     formData.append('escape_task_id', this.task.id)
//                     formData.append('escape_form_num', this.task.form_num)
//                 }
//             }

//             if (this.refImages !== null) {
//                 if (this.refImages.length) {
//                     formData.append('ref_images', JSON.stringify(this.refImages))
//                 }
//             }
//             request.send(formData)
//             request.addEventListener("progress", function(evt) {
//                 if (evt.lengthComputable) {
//                     var percentComplete = (evt.loaded / evt.total) * 100
//                     //Do something with upload progress

//                 }
//             }, false)
//             request.addEventListener("load", function(data) {
//                 console.log(data)
//                 if (data.currentTarget.status === 200) {
//                     if (data.currentTarget.response !== 'exists') {
//                         that.$emit('submitted')
//                         that.$router.push('/task/component/' + data.currentTarget.response)
//                     } else {
//                         swal({
//                             text: 'This form number already exists for this component type!',
//                             type: 'error'
//                         });
//                         Ladda.stopAll();
//                     }
//                 } else {
//                     // that.$router.push('/500')
//                     var obj = {
//                         name: that.formName,
//                         form: that.form
//                     }
//                     that.$store.dispatch('formError', obj)
//                 }
//             })
//         } else {
//             swal({
//                 text: 'You must enter comments and pick a description in order to submit the form!',
//                 timer: 2000,
//                 showConfirmButton: false
//             });
//             Ladda.stopAll();
//         }
//     } else {
//         // if (parseInt(this.form.vendor) !== 1) {
//         //     this.form.vendor_direct = null
//         // }
//         this.form.component_type = this.component_type
//         this.$emit('saved-form')
//     }
// }

methods.feltChanged = function (v) {
    switch (v.felt) {
        case '701 - Fine White': {
            v.yarn = 'DTL800'
            break;
        }
        case '354 - Ivory': {
            v.yarn = 'DTL520'
            break;
        }
        case '516 - Sun Rays': {
            v.yarn = 'DTL546'
            break;
        }
        case 'WM10 - Autumn Glory': {
            v.yarn = 'DTL26'
            break;
        }
        case '365 - Red Light': {
            v.yarn = 'DTL701'
            break;
        }
        case '544 - Sea Surf': {
            v.yarn = 'DTL367'
            break;
        }
        case '373 - Marine Blue': {
            v.yarn = 'DTL335'
            break;
        }
        case '424 - Meadow Green': {
            v.yarn = 'DTL233'
            break;
        }
        case '557 - Maple Green': {
            v.yarn = 'DTL206'
            break;
        }
        case 'P217 - Navy': {
            v.yarn = 'DTL335'
            break;
        }
        case '350 - Parfait Pink': {
            v.yarn = 'DTL103'
            break;
        }
        case '359 - Blush Lavendar': {
            v.yarn = 'DTL676'
            break;
        }
        case '382 - Brown Mahogany': {
            v.yarn = 'DTL738'
            break;
        }
        case '570 - Penguin': {
            v.yarn = 'DTL484'
            break;
        }
        case '714 - Jet Black': {
            v.yarn = 'DTL900'
            break;
        }
        default: {
            break;
        }
    }
}

methods.imageClicked = function(image) {
    if (image.id) {
        this.form.image = image.id
    } else {
        this.form.image = image.file_name
    }
}

methods.checkChecked = function(image) {
    if (image.id) {
        if (this.form.image === image.id) {
            return true
        }
    } else {
        if (this.form.image === image.file_name) {
            return true
        }
    }
    return false
}

methods.factoryClick = function (val) {
    if (this.form.factory_option.indexOf(val) < 0) {
        this.form.factory_option.push(val)
    } else {
        this.form.factory_option.splice(this.form.factory_option.indexOf(val), 1)
    }
}

methods.getCsrs = function() {
    var that = this
    axios.post(this.$apiAdress + '/api/flow/getCsrs?token=' + localStorage.getItem('api_token')).then(response => {
        // if (response.status === 200) {
            this.csr_options = []
            response.data.forEach(function (user) {
                var obj = {
                    value: user.id,
                    label: user.name
                }
                that.csr_options.push(obj)
            })
        // }
    })
}

methods.accountFound = function(obj) {
    this.form.account_number = obj.account_number
    this.form.account_name = obj.account_name
}

methods.imageSelected = function(images) {
    this.refImages = images
}

methods.configureLocationOptions = function () {
    var locationOptions = [
        'Center front',
        'Center back',
        'logo needs to be centered on the band',
        'Back Arch',
        'Front Left Side',
        'Front Right Side',
        'Center logo placed where band meets visor end on left',
        'Center logo placed where band meets visor end on right',
    ]
    if (this.form.component_description !== '') {
        switch (this.form.component_description) {
            case 'all-star retro patch':
                break
            case 'brim sleeve':
                return 'PPBS'
                break
            case 'micro patch':
                locationOptions = [
                    "CENTER FRONT",
                    "CLOSED BACK",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "CENTERED ON RIGHT FRONT PANEL",
                    "WEARER'S FRONT LEFT SIDE PANEL",
                    "WEARER'S FRONT RIGHT SIDE PANEL",
                    "Left Chest",
                ]
                break
            case 'micro patch with 3D details':
                locationOptions = [
                    "CENTER FRONT",
                    "CLOSED BACK",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "CENTERED ON RIGHT FRONT PANEL",
                    "WEARER'S FRONT LEFT SIDE PANEL",
                    "WEARER'S FRONT RIGHT SIDE PANEL",
                    "Left Chest",
                ]
                break
            case 'sublimated faux suede':
                return 'PPSF';
                break
            case '3D insignia embroidery':
                // return 'PPHE';
                locationOptions = [
                    "CENTER FRONT",
                    "CENTER BACK",
                    "BACK ARCH",
                    "FRONT LEFT SIDE",
                    "FRONT RIGHT SIDE",
                ]
                break
            case 'real leather patch':
                return 'PPRL'
                break
            case 'bar code sticker':
                return 'PPBCS'
                break
            case 'chenille patches':
                locationOptions = [
                    "Left Chest",
                    "Left Bicep",
                    "Full Chest",
                    "CENTER FRONT"
                ]
                break
            case 'size sticker strips':
                return 'PPSSS'
                break
            case 'woven retro patch':
                locationOptions = [
                    'Center Front'
                ]
                break
            case 'faux leather patch':
                locationOptions = [
                    "CENTER FRONT",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "CENTERED ON RIGHT FRONT PANEL",
                ]
                break
            case 'infinity edge retro patches':
                locationOptions = [
                    "CENTER FRONT",
                    "CENTER BACK",
                ]
                break
            case 'laser etched faux suede emblems':
                locationOptions = [
                    "CENTER FRONT",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "CENTERED ON RIGHT FRONT PANEL",
                ]
                break
            case 'sublimated retro patch':
                // return 'PPSM'
                locationOptions = [
                    "CENTER FRONT",
                    "CLOSED BACK",
                ]
                break
            case 'flat overlock edge':
                return 'PPE'
                break
            case 'emblem':
                return 'PPE'
                break
            case 'embroidered retro patches':
                locationOptions = [
                    "CENTER FRONT",
                    "CLOSED BACK",
                ]
                break
            case 'fleece twill applique':
                locationOptions = [
                    "FULL CHEST"
                ]
                break
            case 'hangtag':
                return 'PPH'
                break
            case 'header card':
                return 'PPHC'
                break
            case '3D insignia':
                // return 'PPHI'
                locationOptions = [
                    "CENTER FRONT",
                    "CENTER BACK",
                    "BACK ARCH",
                    "FRONT LEFT SIDE",
                    "FRONT RIGHT SIDE",
                ]
                break
            case 'woven label':
                locationOptions = [
                    "CENTER FRONT",
                    "LEFT WEARER'S SIDE",
                    "RIGHT WEARER'S SIDE",
                    "BACK SIDE ARCH",
                    "CENTER BACK",
                    "CENTER FRONT AND BOTH SIDES",
                    "CENTER FRONT AND WEARER'S LEFT SIDE",
                    "CENTER FRONT AND WEARER'S RIGHT SIDE",
                    "CENTERED RIGHT FRONT PANEL AND WEARER'S LEFT SIDE",
                    "CENTERED RIGHT FRONT PANEL AND BOTH SIDES",
                    "CENTERED RIGHT FRONT PANEL AND WEARER'S RIGHT SIDE",
                    "FRONT LEFT SIDE",
                    "CENTERED LEFT FRONT PANEL AND WEARER'S LEFT SIDE",
                    "CENTERED LEFT FRONT PANEL AND BOTH SIDES",
                    "CENTERED LEFT FRONT PANEL AND WEARER'S RIGHT SIDE",
                    "FRONT RIGHT SIDE",
                    "HIGH CENTER BACK",
                    "LOWER RIGHT FRONT PANEL AND WEARER'S LEFT SIDE",
                    "LOWER RIGHT FRONT PANEL AND BOTH SIDES",
                    "LOWER RIGHT FRONT PANEL AND WEARER'S RIGHT SIDE",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER LEFT AND RIGHT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "LEFT WEARER'S BACK",
                    "LOWER LEFT FRONT PANEL AND WEARER'S LEFT SIDE",
                    "LOWER LEFT FRONT PANEL AND BOTH SIDES",
                    "LOWER LEFT FRONT PANEL AND WEARER'S RIGHT SIDE",
                    "CENTERED ON RIGHT FRONT PANEL",
                    "RIGHT WEARER'S BACK",
                    "WEARER'S LEFT AND RIGHT SIDE",
                    "OFF CENTER LEFT FRONT PANEL",
                    "OFF CENTER RIGHT FRONT PANEL",
                ]
                break
            case 'laser etched suede patch':
                locationOptions = [
                    "CENTER FRONT",
                    "CENTERED ON LEFT FRONT PANEL",
                    "LOWER LEFT FRONT PANEL",
                    "LOWER RIGHT FRONT PANEL",
                    "CENTERED ON RIGHT FRONT PANEL",
                ]
                break
            case 'preprice hang tag':
                return 'PPP'
                break
            case 'rubber band (for cap/tees)':
                return 'PPRB'
                break
            case 'hp patch':
                locationOptions = [
                    "CENTER FRONT"
                ]
                break
            case 'sticker':
                return 'PPS'
                break
            case 'size stickers':
                return 'PPSS'
                break
            case 'sublimation marrow edge patch':
                return 'PPSM'
                break
            case 'sublimated label (no merrowed edge)':
                return 'PPSN'
                break
            case 'woven retro patches':
                locationOptions = [
                    "CENTER FRONT"
                ]
                break
            case 'snap label':
                return 'PPSL'
                break
            case 'heat transfer':
                locationOptions = [
                    "CENTER FRONT",
                    "CENTERED ON VISOR BAND",
                    "VISOR BAND LEFT",
                    "VISOR BAND RIGHT",
                    "VISOR TOP LEFT",
                    "VISOR TOP RIGHT",
                    "VISOR LEFT SIDE",
                    "VISOR RIGHT SIDE",
                    "LEFT WEARER'S SIDE BACK PANEL",
                    "LEFT WEARER'S SIDE",
                    "RIGHT WEARER'S SIDE",
                    "BACKSTRAP"
                ]
                break
            default:
                return null
                break
        }
    }
    this.locationOptions = locationOptions
}

export default {
    name: 'ComponentRequest',
    components: {
        SelectImages,
        ReferenceArt
    },
    data: function() {
        return {
            csrArray: '',
            artpackType: false,
            csr_options: null,
            typeOfRequest: 'new',
            formName: 'componentForm',
            refImages: null,
            feltOptions: [
                '701 - Fine White',
                '354 - Ivory',
                '516 - Sun Rays',
                'WM10 - Autumn Glory',
                '362 - Sun Orange',
                '584 - True Red',
                '544 - Sea Surf',
                '376 - Shadow Blue',
                '424 - Meadow Green',
                '602 - Cloud Grey',
                // '558 - Evergreen',
                '387 - Opal Grey',
                '714 - Jet Black',
            ],
            yarnOptions: [
                '220 - Black',
                '101 - Maroon',
                '104 - Columbia Blue',
                '105 - Scarlet Red',
                '106 - Dark Green',
                '108 - Bright White',
                '114 - Dark Red',
                '310 - Light Purple',
                '540 - Royal Blue',
                '620 - Kelly Green',
                '724 - Vegas Gold',
                '726 - Athletic Gold',
                '810 - Orange',
                '107 - Cardinal',
                '209 - Stone Grey',
                '215 - Medium Grey',
                '741 - Old Gold',
                '102 - Navy Blue',
            ],
            techOptions: [
                'Sew Down',
                'Heat Transfer'
            ],
            colorOptions: [
                'Black/Silver',
                'Chestnut/Black',
                'Chocolate/Black',
                'Sandstone/Black',
            ],
            form: {
                style1:'',
                artpack_number: '',
                style2: '',
                form_num: '',
                form_type: '',
                image: '',
                customer_name: '',
                account_name: '',
                account_number: '',
                exact_artpack: '0',
                job_name: '',
                csr_name: '',
                cc_number: '',
                log_number: '',
                factory_option: [],
                g_and_g: 0,
                quantity_info: [{
                    po_number: '',
                    ordered: null,
                    used: '',
                    in_house_date: null
                }],
                turn_time: '2 days',
                component_type: '',
                component_description: '',
                color_option: '',
                yarn_option: '',
                reference_number: '',
                vendor: 0,
                vendor_direct: {
                    company_name: null,
                    contact_name: null,
                    contact_info: null
                },
                comments: '',
                pickleball: ''
            },
            typeOptions: ['bar code sticker', 'chenille patches', 'infinity edge retro patches', 'hangtag', '3D insignia', '3D insignia embroidery', 'embroidered retro patches', 'woven label', 'preprice hang tag', 'sticker', 'size stickers', 'size sticker strips', 'sublimated label (no merrowed edge)', 'woven retro patches', 'snap label', 'heat transfer', 'flat overlock edge', 'sublimated retro patch', 'fleece twill applique', 'micro patch', 'micro patch with 3D details', 'hp patch', 'laser etched faux suede emblems', 'real leather patch', 'sublimated faux suede'],
            options: {
                theme: 'snow'
            },
            locationOptions: [
                'Center front',
                'Center back',
                'logo needs to be centered on the band',
                'Back Arch',
                'Front Left Side',
                'Front Right Side',
                'Center logo placed where band meets visor end on left',
                'Center logo placed where band meets visor end on right',
            ],
            comboOptions: ['1 layer felt - 1 line', '1 layer felt - 2 lines', '2 layer felt - 1 line', '2 layer felt - 2 lines'],
            vendorsOptions: '',
            vendors: {
                weVendor: {
                    array: ['PPE', 'PPCH', 'PPHE', 'PPHI', 'PPL', 'PPSM', 'PPSN', 'PPWE', 'PPMP', 'PPMP3D', 'PPFL', 'PPPV', 'PPFSE', 'PPRL', 'PPSF'],
                    object: 'weObject'
                },
                emblemSource: {
                    array: ['PPAS', 'PPBS'],
                    object: 'emblemObject'
                },
                avery: {
                    array: ['PPBS', 'PPH', 'PPP', 'PPSSS'],
                    object: 'averyObject'
                },
                cbf: {
                    array: ['PPBS', 'PPS', 'PPHT'],
                    object: 'cbfObject'
                },
                diversifiedPacking: {
                    array: ['PPBCS', 'PPSS', 'PPS'],
                    object: 'diversifiedObject'
                },
                pennEmblem: {
                    array: ['PPTA'],
                    object: 'pennObject'
                },
                mainland: {
                    array: ['PPHC', 'PPRB'],
                    object: 'mainlandObject'
                },
                minheng: {
                    array: ['PPL', 'PPLE'],
                    object: 'minhengObject'
                },
                alliance: {
                    array: ['PPRB'],
                    object: 'allianceObject'
                },
                fiontex: {
                    array: ['PPHT'],
                    object: 'fiontexObject'
                },
                subli: {
                    array: ['PPHT'],
                    object: 'subliObject'
                }
            },
            weObject: {
                name: 'World Emblem',
                internal_id: 1499,
                vendor_number:'1225'
            },
            emblemObject: {
                name: 'Emblem Source',
                internal_id: 2247,
                vendor_number:'7864'
            },
            averyObject: {
                name: 'Avery',
                internal_id: 2257,
                vendor_number:'8208'
            },
            cbfObject: {
                name: 'CBF',
                internal_id: 2250,
                vendor_number:'8048'
            },
            diversifiedObject: {
                name: 'Diversified Packing',
                internal_id: 500,
                vendor_number:'1842'
            },
            //pennObject: {
            //    name: 'Penn Emblem',
            //    internal_id: 1915,
            //    vendor_number:'3331'
            //},
            mainlandObject: {
                name: 'Mainland',
                internal_id: 528,
                vendor_number:'8112'
            },
            minhengObject: {
                name: 'Minheng',
                internal_id: 1274,
                vendor_number:'7739'
            },
            allianceObject: {
                name: 'Alliance Rubber',
                internal_id: 2206,
                vendor_number:'6084'
            },
            fiontexObject: {
                name: 'Fiontex',
                internal_id: 1608,
                vendor_number:'2732'
            },
            subliObject: {
                name: 'Subli Transfer',
                internal_id: 5,
                vendor_number:''
            }
        }
    },
    watch: {
        'component_type': function () {
            this.form.felt_yarn_options = ''
            this.form.vendor_selection = ''
            this.configureLocationOptions()
            if (this.component_type === 'PPCH') {
                this.feltOptions = [
                    // '701 - Fine White',
                    // '354 - Ivory',
                    // '516 - Sun Rays',
                    // 'WM10 - Autumn Glory',
                    // '584 - True Red',
                    // '544 - Sea Surf',
                    // '376 - Shadow Blue',
                    // '424 - Meadow Green',
                    // '602 - Cloud Grey',
                    // // '558 - Evergreen',
                    // '714 - Jet Black',
                    'Black - PMS 6C',
                    'Blue - PMS 2186C',
                    'Dark Green- PMS 7728C',
                    'Gold Glitter',
                    'Orange - PMS 179C',
                    'Red - PMS 3517C',
                    'Silver Glitter',
                    'White',
                    'Yellow - PMS 7404C',
                ]
                this.yarnOptions = [
                    '220 - Black',
                    '101 - Maroon',
                    '104 - Columbia Blue',
                    '105 - Scarlet Red',
                    '106 - Dark Green',
                    '108 - Bright White',
                    '114 - Dark Red',
                    '310 - Light Purple',
                    '540 - Royal Blue',
                    '620 - Kelly Green',
                    '724 - Vegas Gold',
                    '726 - Athletic Gold',
                    '810 - Orange',
                    '107 - Cardinal',
                    '209 - Stone Grey',
                    '215 - Medium Grey',
                    '741 - Old Gold',
                    '102 - Navy Blue',
                ]
            } else if (this.component_type === 'PPTA') {
                this.form.color_option = ''
                this.form.yarn_option = ''
                this.feltOptions = [
                    '701 - Fine White',
                    '354 - Ivory',
                    '516 - Sun Rays',
                    'WM10 - Autumn Glory',
                    '365 - Red Light',
                    '544 - Sea Surf',
                    'P217 - Navy',
                    '424 - Meadow Green',
                    '557 - Maple Green',
                    '350 - Parfait Pink',
                    '359 - Blush Lavendar',
                    '382 - Brown Mahogany',
                    '570 - Penguin',
                    // '558 - Evergreen',
                    '714 - Jet Black',
                ]
                this.yarnOptions = [
                    'DTL800',
                    'DTL520',
                    'DTL546',
                    'DTL26',
                    'DTL701',
                    'DTL367',
                    'DTL335',
                    'DTL233',
                    'DTL206',
                    'DTL103',
                    'DTL676',
                    'DTL738',
                    'DTL484',
                    'DTL900'
                ]
                this.comboOptions = ['1 layer felt - 1 line', '1 layer felt - 2 lines', '2 layer felt - 1 line', '2 layer felt - 2 lines', '3 layer felt - 3 lines']
            } else if (this.component_type === 'PPRL') {
                this.form.color_option = ''
                this.feltOptions = [
                    'Caramel- High Contrast',
                    'Caramel- Low contrast',
                    'Natural- High Contrast',
                    'Natural- Low Contrast',
                ]
            } else if (this.component_type === 'PPFSE') {
                this.form.color_option = ''
                this.form.yarn_option = ''
                this.comboOptions = [
                    'Caramel Faux Suede with Satin Overlock Edge: MA 1758 Light',
                    'Caramel Faux Suede with Satin Overlock Edge: MA 1558 Dark',
                    'Pumpkin Spice Faux Suede with Satin Overlock Edge: MA 1899 Light',
                    'Pumpkin Spice Faux Suede with Satin Overlock Edge: MA 1858 Dark',
                    'Bahama Sand Faux Suede with Satin Overlock Edge: MA 1656 Light',
                    'Bahama Sand Faux Suede with Satin Overlock Edge: MA 1945 Dark',
                    'Seattle Gray Faux Suede with Satin Overlock Edge: MA 1741 Light',
                    'Seattle Gray Faux Suede with Satin Overlock Edge: MA 1614 Dark',
                    'Barely Blue Faux Suede with Satin Overlock Edge: MA 1674 Light',
                    'Barely Blue Faux Suede with Satin Overlock Edge: MA 1760 Dark',
                    'Barely Pink Faux Suede with Satin Overlock Edge: MA 1915 Light',
                    'Barely Pink Faux Suede with Satin Overlock Edge: MA 1917 Dark',
                    'Fiji Faux Suede with Satin Overlock Edge: MA 1733 Light',
                    'Fiji Faux Suede with Satin Overlock Edge: MA 1975 Dark',
                    'Coral Faux Suede with Satin Overlock Edge: MA 1707 Light',
                    'Coral Faux Suede with Satin Overlock Edge: MA 1981 Dark',
                    'Aqua Faux Suede with Satin Overlock Edge: MA 1578 Light',
                    'Aqua Faux Suede with Satin Overlock Edge: MA 1903 Dark',
                    'Mustard Yellow Faux Suede with Satin Overlock Edge: MA 1773 Light',
                    'Mustard Yellow Faux Suede with Satin Overlock Edge: MA 1857 Dark',
                ]
                
            }
            var arr = []
            for (var key in this.vendors) {
                if (this.vendors[key].array.indexOf(this.component_type) > -1) {
                    arr.push(this[this.vendors[key].object])
                }
            }
            this.vendorsOptions = arr
            if (arr.length === 1) {
                this.form.vendor_selection = arr[0]
            }
        },
        'form.combo': function () {
            if (this.component_type === 'PPTA') {
                if (this.form.combo === '1 layer felt - 1 line' || this.form.combo === '1 layer felt - 2 lines') {
                    this.form.felt_yarn_options = [{
                        felt: '',
                        yarn: ''
                    }]
                } else if (this.form.combo === '2 layer felt - 1 line' || this.form.combo === '2 layer felt - 2 lines') {
                    this.form.felt_yarn_options = [{
                        felt: '',
                        yarn: ''
                    }, {
                        felt: '',
                        yarn: ''
                    }]
                } else if (this.form.combo === '3 layer felt - 3 lines') {
                    this.form.felt_yarn_options = [{
                        felt: '',
                        yarn: ''
                    }, {
                        felt: '',
                        yarn: ''
                    }, {
                        felt: '',
                        yarn: ''
                    }]
                } else {
                    this.form.felt_yarn_options = ''
                }
            } else {
                this.form.felt_yarn_options = ''
            }
        },
        'form.color_option': function () {
            // if (this.component_type === 'PPTA') {
            //     switch (this.form.color_option) {
            //         case '701 - Fine White': {
            //             this.form.yarn_option = 'DTL800'
            //             break;
            //         }
            //         case '354 - Ivory': {
            //             this.form.yarn_option = 'DTL520'
            //             break;
            //         }
            //         case '516 - Sun Rays': {
            //             this.form.yarn_option = 'DTL546'
            //             break;
            //         }
            //         case 'WM10 - Autumn Glory': {
            //             this.form.yarn_option = 'DTL26'
            //             break;
            //         }
            //         case '365 - Red Light': {
            //             this.form.yarn_option = 'DTL701'
            //             break;
            //         }
            //         case '544 - Sea Surf': {
            //             this.form.yarn_option = 'DTL367'
            //             break;
            //         }
            //         case '373 - Marine Blue': {
            //             this.form.yarn_option = 'DTL335'
            //             break;
            //         }
            //         case '424 - Meadow Green': {
            //             this.form.yarn_option = 'DTL233'
            //             break;
            //         }
            //         case '557 - Maple Green': {
            //             this.form.yarn_option = 'DTL206'
            //             break;
            //         }
            //         case '350 - Parfait Pink': {
            //             this.form.yarn_option = 'DTL103'
            //             break;
            //         }
            //         case '359 - Blush Lavendar': {
            //             this.form.yarn_option = 'DTL676'
            //             break;
            //         }
            //         case '382 - Brown Mahogany': {
            //             this.form.yarn_option = 'DTL738'
            //             break;
            //         }
            //         case '570 - Penguin': {
            //             this.form.yarn_option = 'DTL484'
            //             break;
            //         }
            //         case '714 - Jet Black': {
            //             this.form.yarn_option = 'DTL900'
            //             break;
            //         }
            //         default: {
            //             break;
            //         }
            //     }
            // }
        }
    },
    computed: {
        component_type: function() {
            if (this.form.component_description !== '') {
                switch (this.form.component_description) {
                    case 'all-star retro patch':
                        return 'PPAS'
                        break
                    case 'brim sleeve':
                        return 'PPBS'
                        break
                    case 'micro patch':
                        return 'PPMP'
                        break
                    case 'bar code sticker':
                        return 'PPBCS'
                        break
                    case 'chenille letters':
                        return 'PPCH'
                        break
                    case 'size sticker strips':
                        return 'PPSSS'
                        break
                    case 'retro patch':
                        return 'PPE'
                        break
                    case 'faux leather patch':
                        return 'PPFL'
                        break
                    case 'infinity edge':
                        return 'PPE'
                        break
                    case 'hp+':
                        return 'PPPV'
                        break
                    case 'flat overlock edge-sublimated patch':
                        return 'PPSM'
                        break
                    case 'flat overlock edge':
                        return 'PPE'
                        break
                    case 'hangtag':
                        return 'PPH'
                        break
                    case 'header card':
                        return 'PPHC'
                        break
                    case '3D insignia':
                        return 'PPHI'
                        break
                    case 'printed/woven label':
                        return 'PPL'
                        break
                    case 'laser etched suede patch':
                        return 'PPLE'
                        break
                    case 'preprice hang tag':
                        return 'PPP'
                        break
                    case 'rubber band (for cap/tees)':
                        return 'PPRB'
                        break
                    case 'hp patch':
                        return 'PPPV'
                        break
                    case 'sticker':
                        return 'PPS'
                        break
                    case 'size stickers':
                        return 'PPSS'
                        break
                    case 'sublimation marrow edge patch':
                        return 'PPSM'
                        break
                    case 'sublimated label (no merrowed edge)':
                        return 'PPSN'
                        break
                    case 'woven label marrow edge':
                        return 'PPWE'
                        break
                    case 'snap label':
                        return 'PPSL'
                        break
                    case 'heat transfer':
                        return 'PPHT'
                        break
                    default:
                        return null
                        break
                }
            } else {
                return ''
            }
        }
    },
    methods: methods,
    props: ['newData', 'group'],
    mounted: function() {
        this.getCsrs()

        if (this.newData) {
          const prefill = buildRequestPrefill(this.newData, this.group || {})
          this.form.customer_name = prefill.customerName
          this.form.account_name = prefill.accountName
          this.form.account_number = prefill.accountNumber
          this.form.cc_number = prefill.ccNumber
          this.form.log_number = prefill.logNumber
          this.form.job_name = prefill.title
          this.form.reference_number = prefill.reference
          this.form.comments = prefill.comments
          if (prefill.locationName) {
            this.form.location = [prefill.locationCode, prefill.locationName].filter(Boolean).join(' - ')
          }
        }
    }
}
</script>
